exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".avatar{width:92px;height:92px;float:left;margin-top:-16px}.el-dialog__body{padding-top:8px}.el-dialog__header{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59b75e8a","scoped":false,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/client/pcr-client-establishment-details.vue
// module id = 396
// module chunks = 0